// Категорії витрат monobank: назви (uk/en), іконки й оформлення деталей
// операції. Кольори та шапки зняті зі скріншотів monobank; для категорій,
// яких на скріншотах ще не було (позначено «≈»), — з кольорів їхньої іконки.
//
// icon      — кругла іконка з прозорим фоном (public/category-icons, 256×256)
// from/to   — кольори градієнта кола іконки
// pill      — плашка категорії в деталях (градієнт зліва направо)
// wallet    — коло з гаманцем у блоці «Залишок»
// chart     — градієнт стовпчиків графіка (верх → низ)
// header    — візерунок шапки деталей (1170×369, без обрізки); без нього —
//             суцільний колір from
const CATEGORIES = [
  { key: 'transfer', uk: 'Переказ на картку', en: 'Card transfer', from: '#5450d0', to: '#6e6ee6',
    pill: ['#3733a6', '#403cb3'], wallet: '#3631a3', chart: ['#bb37a7', '#4842b9'], header: '/transfer-header.png' },
  { key: 'appliances', uk: 'Побутова техніка', en: 'Home appliances', from: '#ff5072', to: '#ff845e', // ≈
    pill: ['#e24461', '#e8565f'], wallet: '#e24461', chart: ['#e24461', '#ffb38a'] },
  { key: 'groceries', uk: 'Продукти та супермаркети', en: 'Groceries & supermarkets', from: '#f16020', to: '#fb8e33',
    pill: ['#dd571e', '#e3621f'], wallet: '#dd571e', chart: ['#dd571e', '#f7c06b'], header: '/food-header.png' },
  { key: 'cafes', uk: 'Кафе та ресторани', en: 'Cafes & restaurants', from: '#833dda', to: '#a672f7',
    pill: ['#6036bf', '#663bc7'], wallet: '#5f36bd', chart: ['#6a3ecb', '#de595c'], header: '/transaction-header.png' },
  { key: 'other', uk: 'Інше', en: 'Other', from: '#69848e', to: '#92aeb7',
    pill: ['#44616b', '#47656f'], wallet: '#46636d', chart: ['#436469', '#5ec287'], header: '/other-header.png' },
  { key: 'travel', uk: 'Подорожі', en: 'Travel', from: '#24aa79', to: '#36caa2',
    pill: ['#02938b', '#059c94'], wallet: '#02918a', chart: ['#038d85', '#fa7c7c'], header: '/travel-header.png' },
  { key: 'entertainment', uk: 'Розваги та спорт', en: 'Entertainment & sports', from: '#24aa79', to: '#36caa2',
    pill: ['#02938b', '#059c94'], wallet: '#02918a', chart: ['#038d85', '#fa7c7c'], header: '/entertainment-header.png' },
  { key: 'beauty', uk: "Краса та здоров'я", en: 'Beauty & health', from: '#be3dcb', to: '#e263c5', // ≈
    pill: ['#a8339f', '#b23aa8'], wallet: '#a8339f', chart: ['#a8339f', '#f08fc9'] },
  { key: 'clothes', uk: 'Одяг та взуття', en: 'Clothing & footwear', from: '#ff5072', to: '#ff845e',
    pill: ['#d03a55', '#d6435b'], wallet: '#d03a55', chart: ['#cd3655', '#e4c680'], header: '/clothes-header.png' },
  { key: 'utilities', uk: 'Комуналка та інтернет', en: 'Utilities & internet', from: '#1a7dee', to: '#06a8de',
    pill: ['#3572c9', '#3a80cf'], wallet: '#346fc8', chart: ['#326bc5', '#66ddb5'], header: '/utilities-header.png' },
  { key: 'jar', uk: 'Банка', en: 'Jar', from: '#915cb9', to: '#c89bce', // ≈
    pill: ['#7d4fa3', '#8656ab'], wallet: '#7d4fa3', chart: ['#7d4fa3', '#d6b0db'] },
  { key: 'flowers', uk: 'Квіти', en: 'Flowers', from: '#be3dcb', to: '#e263c5', // ≈
    pill: ['#a8339f', '#b23aa8'], wallet: '#a8339f', chart: ['#a8339f', '#f08fc9'] },
  { key: 'cinema', uk: 'Кіно', en: 'Cinema', from: '#833dda', to: '#a672f7', // ≈
    pill: ['#6036bf', '#663bc7'], wallet: '#5f36bd', chart: ['#6a3ecb', '#de595c'] },
  { key: 'mobile', uk: 'Поповнення мобільного', en: 'Mobile top-up', from: '#69848e', to: '#92aeb7', // ≈
    pill: ['#44616b', '#47656f'], wallet: '#46636d', chart: ['#436469', '#5ec287'] },
  { key: 'taxi', uk: 'Таксі', en: 'Taxi', from: '#715e5a', to: '#997e76',
    pill: ['#533e3a', '#5a4541'], wallet: '#513e3a', chart: ['#4f3b37', '#eb6666'], header: '/taxi-header.png' },
  { key: 'repairs', uk: 'Ремонт', en: 'Repairs', from: '#ff5072', to: '#ff845e', // ≈
    pill: ['#e24461', '#e8565f'], wallet: '#e24461', chart: ['#e24461', '#ffb38a'] },
  { key: 'iban', uk: 'Платіж за IBAN', en: 'IBAN payment', from: '#9f721e', to: '#bb9230', // ≈
    pill: ['#9b6e1c', '#9b6e1c'], wallet: '#9b6e1c', chart: ['#f5c661', '#c1983a'], header: '/iban-header.png' },
  { key: 'auto', uk: 'Авто', en: 'Auto', from: '#715e5a', to: '#997e76', // ≈
    pill: ['#533e3a', '#5a4541'], wallet: '#513e3a', chart: ['#4f3b37', '#eb6666'] },
].map((c) => ({ ...c, icon: `/category-icons/${c.key}.png` }));

export const CATEGORY_BY_KEY = Object.fromEntries(CATEGORIES.map((c) => [c.key, c]));

// Поповнення (дохід) — окреме оформлення: чорна плашка без олівця
export const TOPUP_STYLE = {
  key: 'topup', uk: 'Поповнення картки', en: 'Card top-up',
  pill: ['#000000', '#000000'], wallet: '#000000', chart: ['#000000', '#000000'], header: '/jar-header.png', editable: false,
};

// Старі ключі транзакцій (бот і застосунок до розширення категорій)
const LEGACY = { Food: 'groceries', Cafe: 'cafes', Clothes: 'clothes', Transfer: 'transfer', Other: 'other' };

// Ключ категорії транзакції → оформлення (старі ключі теж)
export function categoryStyle(category) {
  if (category === 'ADD' || category === 'ADD_TRANSFER') return TOPUP_STYLE;
  const c = CATEGORY_BY_KEY[LEGACY[category] || category];
  return c ? { ...c, editable: true } : { ...CATEGORY_BY_KEY.other, uk: 'Невідома категорія', editable: true };
}

// Однаковий ключ для порівняння (Food і groceries — одна категорія)
export const normalizeCategory = (category) => LEGACY[category] || category;

export default CATEGORIES;
